export default function ThankYou() {
  return (
    <div className="thankyou-overlay">
      <div className="thankyou-card">
        <p className="page-eyebrow">Brinkmann Constructors</p>
        <h1>Submission received</h1>
        <p className="page-lede">Your project setup submission has been received.</p>
        <a className="btn-secondary" href="/">Submit another</a>
      </div>
    </div>
  );
}
